"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const payloadMutator_1 = __importDefault(require("./payloadMutator"));
const MAX_RETRIES = 3;
const HTTP_INTERNAL_SERVER_ERROR = 500;
class ApiClient {
    constructor(apiEndpoint, logger) {
        this.apiEndpoint = apiEndpoint;
        this.logger = logger;
        this.mutator = new payloadMutator_1.default();
    }
    sendRequest(events_1) {
        return __awaiter(this, arguments, void 0, function* (events, currentTry = 1) {
            var _a;
            const environment = (_a = window.App.appEnvironment) !== null && _a !== void 0 ? _a : false;
            if (environment !== "production" &&
                environment !== "staging") {
                console.log("Events sent", events);
                return Promise.resolve(new Response());
            }
            const payload = this.mutator.mutatePayload(events); // Use the Event type in the mutatePayload method
            const response = yield fetch(this.apiEndpoint, {
                method: "POST",
                body: payload,
            });
            if (this.hasRequestFailed(response)) {
                if (currentTry < MAX_RETRIES) {
                    return this.sendRequest(events, ++currentTry);
                }
                this.logger.captureException(new Error("Failed to send events"), {
                    extra: {
                        payload: JSON.parse(payload),
                        status: response.status,
                    }
                });
            }
            return response;
        });
    }
    hasRequestFailed(response) {
        return !response.status || response.status >= HTTP_INTERNAL_SERVER_ERROR;
    }
}
exports.default = ApiClient;
